<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
      <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
        <span *ngIf="status"><i class="fas fa-angle-right"></i></span>

        <span *ngIf="!status"><i class="fas fa-angle-left"></i></span>
      </div>
      <div class="sidebar-header">
          <h3>Exemptions</h3>
      </div>

      <ul class="list-unstyled components">

        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="homeowner-exemption">{{'NavMenu.HomeExv2'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="disabled-veterans">{{'NavMenu.DisabledVets'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="church">{{'NavMenu.Churches'|translate}}</a>
        </li>
        <!--<li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="religious">{{'NavMenu.Religious'|translate}}</a>
        </li>-->
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="non-profit">{{'NavMenu.NonProfits'|translate}}</a>
        </li>
        <!--<li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="welfare">Welfare</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="hospital-property">Hospital Property</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="multispecialty-clinics">Multispecialty Clinics</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="housing">Housing</a>
        </li>-->
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="veterans">{{'Veterans.SearchTitle'|translate}}</a>
        </li>
      </ul>

  </nav>
  <div id="content">

            <!-- <button type="button" id="sidebarCollapse" (click)="status=!status" class="btn btn-info">
                <i class="fas fa-align-left"></i>
                <span>Toggle Sidebar</span>
            </button> -->
            <router-outlet></router-outlet>
</div>


</div>
